import { FILE_DETAIL_FILTER_VALUES } from "lib/utils/fileDetailFilters";
import { getFusionResultLabel } from "lib/utils/fusionResult";

function translate(t, key, options = {}) {
  return typeof t === "function" ? t(key, options) : options.defaultValue || key;
}

export function buildProjectDetailFilterGroups({
  t,
  i18n,
  includeAll = false,
  allGroupKey = "all",
  allValue = "all",
} = {}) {
  const groups = [];

  if (includeAll) {
    groups.push({
      key: allGroupKey,
      label: translate(t, "projectDetail.projectReportEditor.filter.groups.loadScope", {
        defaultValue: "Load scope",
      }),
      options: [
        {
          value: allValue,
          label: translate(t, "projectDetail.projectReportEditor.filter.all", {
            defaultValue: "All",
          }),
        },
      ],
    });
  }

  groups.push(
    {
      key: "fileType",
      label: translate(t, "projectDetail.fileList.detailFilter.groups.fileType", {
        defaultValue: "File type",
      }),
      options: [
        {
          value: "image",
          label: translate(t, "projectDetail.fileList.fileType.image", {
            defaultValue: "Image",
          }),
        },
        {
          value: "video",
          label: translate(t, "projectDetail.fileList.fileType.video", {
            defaultValue: "Video",
          }),
        },
      ],
    },
    {
      key: "facilityType",
      label: translate(t, "projectDetail.fileList.detailFilter.groups.facilityType", {
        defaultValue: "Facility type",
      }),
      options: [
        {
          value: FILE_DETAIL_FILTER_VALUES.facilityType[0],
          label: translate(t, "projectDetail.fileList.facilityType.electric", {
            defaultValue: "Electrical Facility",
          }),
        },
        {
          value: FILE_DETAIL_FILTER_VALUES.facilityType[1],
          label: translate(t, "projectDetail.fileList.facilityType.gas", {
            defaultValue: "Gas Facility",
          }),
        },
        {
          value: FILE_DETAIL_FILTER_VALUES.facilityType[2],
          label: translate(t, "projectDetail.fileList.facilityType.machine", {
            defaultValue: "Mechanical Facility",
          }),
        },
      ],
    },
    {
      key: "fusionResult",
      label: translate(
        t,
        "projectDetail.fileList.detailFilter.groups.inspectionResult",
        {
          defaultValue: "Inspection result",
        },
      ),
      options: FILE_DETAIL_FILTER_VALUES.fusionResult.map((code) => ({
        value: code,
        label: getFusionResultLabel(code, i18n, {
          variant: "image",
          fallback: code,
        }),
      })),
    },
  );

  return groups;
}
